import React from 'react';
import "./footer.css";
import { BsLinkedin } from "react-icons/bs";
import { GiCornerFlag } from "react-icons/gi";
import { Link } from 'react-router-dom';
import { SiHackthebox } from "react-icons/si";
import NAV_LINKS from '../../../Utils/navLinks';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="bar wrap fcb">
        <div className="links fcs">
          {
            NAV_LINKS.map(({ to, label }) => (
              <Link className="link" to={to} key={to}>{label}</Link>
            ))
          }
        </div>
        <div className="socials fcc">
          <a href="https://app.hackthebox.com/profile/1666286" target='_blank' rel="noreferrer" aria-label="HackTheBox"><SiHackthebox /></a>
          <a href="https://www.linkedin.com/in/chai-cheng-xun" target='_blank' rel="noreferrer" aria-label="LinkedIn"><BsLinkedin /></a>
          <a href="https://qiaonpc.github.io/" target='_blank' rel="noreferrer" aria-label="Blog"><GiCornerFlag /></a>
        </div>
        <div className="copyright">&copy; Copyright 2021 - {currentYear} Chai Cheng Xun</div>
      </div>
    </footer>
  )
}

export default Footer
